import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { Meeting } from '@app/core/model/entities/meeting/meeting';
import { WorkInput } from '@app/core/model/entities/works/work';
import {
  WorkCreateModalComponent
} from '@app/features/main/views/works/works-inventory/modals/work-create-modal/work-create-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';

@Component({
  templateUrl: '../../../../works/works-inventory/modals/work-create-modal/work-create-modal.component.html',
  standalone: false
})
export class MeetingWorkCreateModalComponent extends WorkCreateModalComponent implements OnInit {

  protected readonly data: { meeting: Meeting } = inject(MAT_DIALOG_DATA);

  private readonly translate = inject(TranslateService);

  /**
   * Initialise missing required fields.
   */
  public ngOnInit(): void {
    super.ngOnInit();
    const defaultMissingRequiredFields = [{code: 'meetingId', label: this.translate.instant('LABEL.MEETING')}]
      .filter(({code}) => !this.accessManager.hasFieldWriteOnCreateAccess(code, EntityTypeEnum.WORK));
    this.missingRequiredFields$ = this.missingRequiredFields$.pipe(
      map(fields => fields.concat(defaultMissingRequiredFields)),
    );
  }

  /**
   * Data from the filled form.
   * @return Work data.
   */
  public override getGeneratedObject(): WorkInput {
    return {
      ...super.getGeneratedObject(),
      meetingId: this.data.meeting.id
    };
  }
}
